import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import dompurify from "isomorphic-dompurify";
import { __ } from "@jti/fe-common";
import { prepareOrderAttributes, } from "@jti/magento";
import { fetchOrderAttributes, selectOrderAttributes, useDispatch, useSelector } from "@jti/store";
import { Box, DEPRECATED_Card, formatDate, useConfig } from "@jti/ui";
import Prices from "../../../../components/Prices/Prices";
import { useAemModel } from "../../../../contexts/AemModelContext";
import getCartItemsCount from "../../../../utils/getCartItemsCount";
import OrderAddresses from "./OrderAddress";
import OrderDotContent from "./OrderDotContent";
import OrderItems from "./OrderItems";
import OrderLabel from "./OrderLabel";
import OrderPaymentMethod from "./OrderPaymentMethod";
import styles from "./Order.module.scss";
const { sanitize } = dompurify;
const getCurrentTitle = (count = 0) => {
    if (count <= 1) {
        return __("cart.order.summary.title.single");
    }
    return __("cart.order.summary.title", [count || 0]);
};
export const Order = ({ order, paymentMethod, isFreeTrial = false, prices }) => {
    const { zeroValueOrder } = useAemModel();
    const { COUNTRY_NAME } = useConfig();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchOrderAttributes(isFreeTrial));
    }, [dispatch, isFreeTrial]);
    const orderAttributes = useSelector(selectOrderAttributes);
    const zeroValueOrderNotification = zeroValueOrder?.userNotification || "";
    const [shippingAttributes, setShippingAttributes] = useState([]);
    const [billingAttributes, setBillingAttributes] = useState([]);
    const itemsCount = getCartItemsCount(order?.items ?? []);
    useEffect(() => {
        if (order?.additional_attributes && orderAttributes.length) {
            const { updatedShippingAttributes, updatedBillingAttributes } = prepareOrderAttributes(order.additional_attributes, orderAttributes);
            setShippingAttributes(updatedShippingAttributes);
            setBillingAttributes(updatedBillingAttributes);
        }
    }, [order, orderAttributes]);
    return (_jsxs("div", { className: styles.OrderContainer, children: [_jsxs("div", { className: styles.numberDate, children: [_jsxs(OrderLabel, { title: "cart.order.number", className: styles.orderNumber, children: [_jsx("span", { children: "#" }), _jsx("span", { children: order?.number || "000000000" })] }), _jsx(OrderLabel, { title: "cart.order.date", className: styles.orderDate, children: order?.orderDate ? formatDate(order.orderDate) : "..." })] }), _jsxs("div", { className: styles.boxes, children: [_jsx(OrderAddresses, { address: {
                            ...order?.shippingAddress,
                            countryName: COUNTRY_NAME, // DESP-65624
                        }, className: styles.shipping, title: "cart.order.shipping_address.title", orderAttributesInfos: shippingAttributes }), _jsx(OrderAddresses, { address: {
                            ...order?.billingAddress,
                            countryName: COUNTRY_NAME, // DESP-65624
                        }, className: styles.billing, title: "cart.order.billing_address.title", orderAttributesInfos: billingAttributes }), _jsx(OrderDotContent, { condition: !!order?.shippingMethod?.methodCode, className: styles.delivery, title: "cart.order.delivery_method.title", children: order?.shippingMethod?.methodCode }), _jsx(Box, { className: styles.payment, title: __("cart.order.payment_method.title"), accent: true, children: order?.isZeroValueOrder ? (_jsx("div", { "data-testid": "zervo-value-order-notification", dangerouslySetInnerHTML: {
                                __html: sanitize(zeroValueOrderNotification),
                            } })) : (_jsx(OrderPaymentMethod, { paymentMethod: paymentMethod })) }), _jsxs(DEPRECATED_Card, { title: getCurrentTitle(itemsCount), className: styles.card, variant: "variant4", classNameTitle: styles.summaryTitle, children: [_jsx(OrderItems, { isFreeTrial: isFreeTrial, className: styles.items, items: order?.items }), _jsx("div", { className: styles.title, children: __("cart.payment_summary.title") }), _jsx(Prices, { prices: prices, isFreeTrial: isFreeTrial })] })] })] }));
};
export default memo(Order);
//# sourceMappingURL=index.js.map